export enum OrderState {
	NOT_IN_CART = 'NOT_IN_CART',
	IN_CART = 'IN_CART',
	ORDERED = 'ORDERED',
	ACCEPTED = 'ACCEPTED',
	DECLINED = 'DECLINED',
	PROCESSING = 'PROCESSING',
	INVALID = 'INVALID'
}
